<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-divider>确认发票信息</van-divider>

            <van-cell-group>

                <van-field
                        v-model="row.fapiao_taitou"
                        :rules="[{ required: true, message: '发票抬头不能为空' }]"
                        label="发票抬头"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入发票抬头"
                />
                <van-field
                        v-model="row.fapiao_shuihao"
                        :rules="[{ required: true, message: '税号不能为空' }]"
                        label="税号"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入税号"
                />
                <div class="operate-desc-left">如果您所在的单位没有纳税人识别号请填写“无”</div>

                <van-field
                        v-model="row.fapiao_beizhu"
                        label="发票备注"
                        input-align="right"
                        clearable
                        placeholder="请输入发票备注"
                />
                <van-field
                        v-model="row.fapiao_email"
                        :rules="[{ validator: validator.email, message: '请输入正确的邮箱' }]"
                        error-message-align="right"
                        label="接收邮箱"
                        input-align="right"
                        clearable
                        placeholder="请输入接收邮箱"
                />
                <van-field
                        v-model="row.fapiao_phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="接送手机"
                        input-align="right"
                        clearable
                        placeholder="请输入接送手机"
                />

                <div class="fapiao-tip-wrap" style="display:none">
                    <div>
                        <!--发票1 金额：{{parseInt(row.order.memberprice)+parseInt(row.order.otherprice)}}元  名目：赛事综合服务费-->
                    </div>
                    <div v-show="row.order.shisuprice>0">
                        <!--发票2 金额：{{row.order.shisuprice}}元  名目：食宿费-->
                    </div>
                </div>
                <div style="height: 0.2rem"></div>
                <div style="text-align: center" v-show="false">
                    <van-button
                            style="width: 3rem; margin: 10px;"
                            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">确认发票信息</van-button>
                </div>

            </van-cell-group>


            <van-divider>费用信息</van-divider>

            <van-cell-group>

                <van-cell
                        input-align="right"
                        title="费用总计"
                        :value="row.order.total"
                />

            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">确定提交</van-button>
            </div>
        </van-form>


        <PayDialog :show="payDialogShow" scene="cba" :ids="orderIds" @onPayError="onPayError" @onPaySuccess="onPaySuccess"
                   @onPayClose="onPayClose"/>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{

                    }
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.row.apply_id = this.$route.query.apply_id;
            if(that.row.apply_id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/cba/ordersave', that.row, (res) => {
                    that.saveLoading = false;

                    that.orderIds = res.data.ids;
                    that.payDialogShow = true;

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/cba/orderFormDetail', {
                    apply_id:that.row.apply_id
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },

            onPayError() {
                let that = this;
                console.log('onPayError 支付失败');
                that.payDialogShow = false;

                that.$toast('支付失败');

                rbLink({
                    name:'ISaiApplyList'
                },'replace')

            },
            onPaySuccess() {
                let that = this;
                console.log('onPaySuccess 支付成功');
                that.payDialogShow = false;


                appEvent({
                    name: 'saiApplyDetailReload',
                    query: {
                    }
                });

                setTimeout(function () {
                    rbLink({
                        name:'CbaApplyList',
                        query:{
                        }
                    },'replace')

                },500);

            },
            onPayClose() {
                let that = this;
                console.log('onPayClose 支付关闭');
                that.payDialogShow = false;



                setTimeout(function () {
                    rbLink({
                        name:'CbaApplyList'
                    },'replace')

                },500);
            }


        }
    }
</script>



// WEBPACK FOOTER //
// CbaApplyFormOrder.vue?315cbffe